// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__43Zq5","header":"MessagesList_header__vAGO7","chat":"MessagesList_chat__3WMr7"};